import React, { useContext, useEffect, useState } from "react";
import {
  SearchableList,
  FieldDropSide,
  FieldTextarea,
  DatePicker,
  SliderPanel,
} from "../../../components";
import { usCurrency } from "../../../utils";
import { Formik, Field } from "formik";
import { Form, Button, Modal, Image } from "react-bootstrap";
import { isEmpty, get } from "lodash";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useRequest } from "../../../abstracts";
import { ManageForfeitureLayout } from "../../../components";

import {
  getForfeitureSummaryDetails,
  getForfeitureSourceHistoryTransactions,
} from "../../../services";

const initialValues = {
  companyName: "Select One",
  companyId: null,
  planName: "All",
  planID: "All",
  planYear: "Select One",
  sliderSearchTransaction: null,
  sliderSearchEmployeee: null,
  sliderSearchSSN: null,
  sliderSearchStartDate: null,
  sliderSearchEndDate: null,
};

const ForfeitureSummaryContainer = (props) => {
  const { response: data } = useRequest({
    method: getForfeitureSummaryDetails,
    defaultResponse: [],
  });

  const company = [
    { CompanyName: "Amazon" },
    { CompanyName: "Salesforce" },
    { CompanyName: "Dunzo" },
    { CompanyName: "Facebook" },
  ];

  const plan = [
    { planName: "Mail Testing Plan " },
    { planName: "Prod Plan" },
    { planName: "IA plan" },
    { planName: "AEP plan" },
  ];

  const planID = [
    { planID: "453" },
    { planID: "777" },
    { planID: "450" },
    { planID: "401" },
  ];

  const planYear = [
    { planYear: "2019" },
    { planYear: "2020" },
    { planYear: "2021" },
    { planYear: "2022" },
  ];

  const [isSliderOpen, setIsSliderOpen] = useState(false);

  const [expandData1, setExpandData1] = useState([]);

  useEffect(() => {
    !isEmpty(data) &&
      data.payrollForfeitureDetails.map((item) => {
        return {
          ...item,
          totalForfeitureBalance: "",
        };
      });
    !isEmpty(data) &&
      setExpandData1(
        data.payrollForfeitureDetails.map((item) => {
          let amount = 0;
          let TotalUnits = 0;
          const initialPart = item.planStartDate.split(/[- : T]/);
          const initialDate =
            initialPart[1] + "/" + initialPart[2] + "/" + initialPart[0];
          const finalPart = item.planEndDate.split(/[- : T]/);
          const endDate =
            finalPart[1] + "/" + finalPart[2] + "/" + finalPart[0];
          const planPeriod = initialDate + "-" + endDate;
          item.sourceDetails.map((item) => {
            amount = amount + item.balance;
            TotalUnits = TotalUnits + item.units;
          });
          return {
            ...item,
            totalForfeitureBalance: amount,
            units: TotalUnits,
            displayStartdate: initialDate,
            displayEndDate: endDate,
            planPeriod: planPeriod,
            planYear: initialPart[0],
          };
        })
      );
  }, [data]);

  //Declaring state variables for the slider panel
  const [SPData, setSPData] = useState([]);
  const [sliderPlanName, setSliderPlanName] = useState();
  const [sliderPlanID, setSliderPlanID] = useState();
  const [sliderPlanYear, setSliderPlanYear] = useState();
  const [sliderInvestmentName, setSliderInvestmentName] = useState();
  const [sourceHistorySourceId, setSourceHistorySourceId] = useState(0);
  const [sourceHistoryPlanId, setsourceHistoryPlanId] = useState(0);
  const [
    sourceTransactionsAPIOutput,
    setSourceTransactionsAPIOutput,
  ] = useState([]);

  const SliderPanelDataUpdate = (item, dataItem) => {
    setIsSliderOpen(true);
    setSPData(item);
    setSliderPlanName(dataItem.planName);
    setSliderPlanID(dataItem.rkPlanNumber);
    setSliderInvestmentName(dataItem.investmentName);
    setSliderPlanYear(dataItem.planYear);
    setsourceHistoryPlanId(dataItem.planId);
    setSourceHistorySourceId(item.sourceId);
    getForfeitureSourceHistoryTransactions({
      sourceId: sourceHistorySourceId,
      planId: sourceHistoryPlanId,
    }).then((response) => {
      setSourceTransactionsAPIOutput(response);
    });
  };

  //New changes
  const expandChange = (event) => {
    let newData = expandData1.map((item) => {
      if (item.planId === event.dataItem.planId) {
        item.expanded = !event.dataItem.expanded;
      }

      return item;
    });
    setExpandData1(newData);
  };

  const DetailComponent = (props) => {
    const dataItem = props.dataItem;

    return dataItem.sourceDetails.map((item) => {
      return (
        <div className="ForfeitureSourceCard">
          <div className="ForfeitureSourceName">{item.sourceName}</div>
          <div className="ForfeitureSourceBalance">
            <span style={{ color: "grey", fontSize: "14px" }}>Balance</span>
            {usCurrency(item.balance)}
          </div>
          <div className="ForfeitureSourceUnits">
            <span style={{ color: "grey", fontSize: "14px" }}>Units</span>{" "}
            {item.units}
          </div>
          <div
            className="ForefitureLinkSourceHistory"
            onClick={() => SliderPanelDataUpdate(item, dataItem)}
          >
            Source history
          </div>
          <SliderPanel
            isOpen={isSliderOpen}
            size="75"
            title=" Source History"
            onClose={() => setIsSliderOpen(false)}
            // showCancel={false}
            backdropClicked={() => setIsSliderOpen(false)}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="ForfeitureSliderHeading">Source History</div>
            </div>
            <div className="ForfeitureSliderGeneralInfo">
              <div className="SourceCardTitle" style={{ width: "13rem" }}>
                <div className="SourceHistoryTopic">Plan name</div>
                <div className="SliderInputProp">{sliderPlanName}</div>
              </div>
              <div className="SourceCardTitle">
                <div className="SourceHistoryTopic">Plan ID</div>
                <div className="SliderInputProp">{sliderPlanID}</div>
              </div>
              <div className="SourceCardTitle">
                <div className="SourceHistoryTopic">Plan year</div>
                <div className="SliderInputProp">{sliderPlanYear}</div>
              </div>
              <div className="SourceCardTitle">
                <div className="SourceHistoryTopic">Investment name</div>
                <div className="SliderInputProp">{sliderInvestmentName}</div>
              </div>
              <div className="SourceCardTitle">
                <div className="SourceHistoryTopic">Source</div>
                <div className="SliderInputProp">{SPData.sourceName}</div>
              </div>
              <div className="SourceCardTitle">
                <div className="SourceHistoryTopic">Units</div>
                <div className="SliderInputProp">{SPData.units}</div>
              </div>
            </div>
            {/* <div>
              Searchbox
            </div> */}
            {/*These cards should be Rendered within a loop based on the transaction details from the api*/}
            {!isEmpty(sourceTransactionsAPIOutput) &&
              sourceTransactionsAPIOutput.transactionDetails.map((item) => {
                return (
                  <div className="ForFeitureSourceHistoryTransactionDetails">
                    <div
                      className={
                        item.type === "In"
                          ? "SourceTransactionIn"
                          : "SourceTransactionOut"
                      }
                    >
                      <div>
                        <div className="SourceTransactionAmount">
                          {usCurrency(item.amount)} - {item.type}
                        </div>
                        <div className="SourceTransactionDate">9/12/2021</div>
                      </div>
                    </div>
                    <div className="TransactionSourceNameInvestment">
                      <div>
                        <div style={{ fontWeight: "500", fontSize: "20px" }}>
                          {SPData.sourceName}
                        </div>
                        <div style={{ color: "grey" }}>
                          {sliderInvestmentName}
                        </div>
                      </div>
                    </div>
                    <div className="TransactionSourceNameInvestment">
                      {item.type === "In" ? (
                        <div className="FileDetails">
                          <div style={{ color: "grey" }}>
                            Permissible Withdrawl
                          </div>
                          <div style={{ fontWeight: "500" }}>
                            {item.employeeName} | {item.ssn}
                          </div>
                        </div>
                      ) : (
                        <div className="FileDetails">
                          <div style={{ color: "grey" }}>Payroll</div>
                          <div style={{ fontWeight: "500" }}>
                            {item.fileName}
                          </div>
                        </div>
                      )}
                    </div>
                    <div
                      className="TransactionSourceNameInvestment"
                      style={{ width: "11rem" }}
                    >
                      <div>
                        <div style={{ color: "grey" }}>Units</div>
                        <div style={{ fontWeight: "500" }}>{item.units}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </SliderPanel>
        </div>
      );
    });
  };

  return (
    <ManageForfeitureLayout layoutHeader={"Forfeiture Summary"}>
      <Formik
        initialValues={{
          ...initialValues,
        }}
        // onSubmit={onSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          values,
          ...rest
        }) => {
          return (
            <Form
              autoComplete="off"
              className="mb-20 mt-10"
              onSubmit={handleSubmit}
              validated={!isEmpty(rest.errors)}
            >
              <div>
                {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                <div className="ForfeitureSummarySeachContainer">
                  <div className="topicName">
                    <Field
                      size="sm"
                      isRequired
                      label="Company Name"
                      noLabelTransform
                      name={values.companyName}
                      value={values.companyName}
                      placeholder="Select One"
                      direction="bottom"
                      popupContent={
                        <SearchableList
                          label="Select Company"
                          size="sm"
                          options={[
                            ...company.map((company, index) => ({
                              label: company.CompanyName,
                              value: index,
                            })),
                          ]}
                          onSelect={(value) => {}}
                          selectedValue={values.companyName}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div className="topicName">
                    <Field
                      size="sm"
                      isRequired
                      label="Plan ID"
                      noLabelTransform
                      name={values.planID}
                      value={values.planID}
                      placeholder="Select One"
                      direction="bottom"
                      popupContent={
                        <SearchableList
                          label="Select Plan ID"
                          size="sm"
                          options={[
                            ...planID.map((planID, index) => ({
                              label: planID.planID,
                              value: index,
                            })),
                          ]}
                          onSelect={(value) => {}}
                          selectedValue={values.planID}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div className="topicName">
                    <Field
                      size="sm"
                      isRequired
                      label="Plan Name"
                      noLabelTransform
                      name={values.planName}
                      value={values.planName}
                      placeholder="Select One"
                      direction="bottom"
                      popupContent={
                        <SearchableList
                          label="Select Plan Name"
                          size="sm"
                          options={[
                            ...plan.map((plan, index) => ({
                              label: plan.planName,
                              value: index,
                            })),
                          ]}
                          onSelect={(value) => {}}
                          selectedValue={values.planName}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div className="topicName">
                    <Field
                      size="sm"
                      isRequired
                      label="Plan Year"
                      noLabelTransform
                      name={values.planYear}
                      value={values.planYear}
                      placeholder="Select One"
                      direction="bottom"
                      popupContent={
                        <SearchableList
                          label="Select Plan Year"
                          size="sm"
                          options={[
                            ...planYear.map((item, index) => ({
                              label: item.planYear,
                              value: index,
                            })),
                          ]}
                          onSelect={(value) => {}}
                          selectedValue={values.planYear}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                  <div className="topicNameSearch">
                    <div className="ForfeitureSearchButton">
                      <Button
                        className="sort-button"
                        size="sm"
                        variant="secondary"
                        type="submit"
                      >
                        Search
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="ForfeitureTableHeading">Forfeiture Summary</div>
                <div className="ForfeitureGrid">
                  <Grid
                    data={expandData1}
                    detail={DetailComponent}
                    expandField="expanded"
                    onExpandChange={expandChange}
                  >
                    <GridColumn
                      field="rkPlanNumber"
                      title="Plan ID"
                      width="75px"
                      className="product-name"
                    />
                    <GridColumn
                      field="planName"
                      title="Plan Name"
                      width="150px"
                    />
                    <GridColumn
                      field="planPeriod"
                      title="Plan Period"
                      width="220px"
                    />
                    <GridColumn
                      field="totalForfeitureBalance"
                      title="Total Forfeiture Balance"
                      width="200px"
                      format="{0:c2}"
                    />
                    <GridColumn
                      field="investmentName"
                      title="Investment Name"
                      width="175px"
                    />
                    <GridColumn field="units" title="Units" />
                    <GridColumn field="nav" title="NAV" format="{0:c2}" />
                  </Grid>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </ManageForfeitureLayout>
  );
};

export default ForfeitureSummaryContainer;
